module.exports = __webpack_public_path__ + "static/media/Peace_and_Calm.ab12c22b.mp3";